import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Global from '../../../store/global-selectors';
import { MarketplacesColumnContainer } from '../../../containers/marketplaces-column-container';
import { messages } from './messages';

const MarketplaceUsernamesColumn = ({ customerId }) => {
  const [customer] = useSelector((state) => Global.selectEntitiesCustomersByIds(state, { customerIds: [customerId] })) ?? [];

  const marketplaces = customer?.marketplaces || [];

  if (!marketplaces.length) {
    return '';
  }

  if (marketplaces.length > 1) {
    return <FormattedMessage defaultMessage='(Multiple)' description='customersGrid.columns.multiple' id='5aBDQq' />;
  }

  return (
    <MarketplacesColumnContainer
      marketplaceId={marketplaces[0].marketplaceId}
      marketplaceUsername={marketplaces[0].username}
      type='marketplaceUsernames'
    />
  );
};

export const MarketplaceUsernames = {
  getMessageDescriptor: () => messages.marketplaceUsernames,
  id: 'marketplace-usernames',

  render: ({ customerId }) => {
    return <MarketplaceUsernamesColumn customerId={customerId} />;
  },
};
